module.exports = __webpack_public_path__ + "media/contractor-reporting/how-many-hours-4d5d5105.png";